module.exports = __webpack_public_path__ + "fax.png?f513f3ae5b25e1bec455a51ccd90d490";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fax.png
// module id = 191
// module chunks = 0